import PropTypes from "prop-types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import SpinnerImage from "../assets/img/spinner.gif";
import NotAuthorized from "../components/NotAuthorized.jsx";
import { selectUser } from "../store/selectors.js";
import { hasPermissions } from "../store/thunks.js";

const PrivateRoute = ({ element, resourceType, resourceKey }) => {
  const user = useSelector(selectUser);
  const permissionsFetched = useSelector(
    (state) => state.session?.permissionsFetched,
  );
  const dispatch = useDispatch();
  const location = useLocation();

  // If no user is logged in, redirect to the login page.
  if (!user) {
    return (
      <Navigate
        to={{
          pathname: "/login",
          search: `?from=${location.pathname}`,
          state: { from: location },
        }}
        replace
      />
    );
  }

  if (resourceType && resourceKey) {
    const authorized = dispatch(hasPermissions(resourceType, resourceKey));
    if (!authorized) {
      if (!permissionsFetched) {
        return (
          <div className="infinite-loading">
            <div className="arriva-spinner">
              <img src={SpinnerImage} alt="Loading..." />
            </div>
          </div>
        );
      }
      // If permissions are available but user is not authorized, show NotAuthorized.
      return <NotAuthorized />;
    }
  }

  // Otherwise, render the provided element.
  return element;
};

PrivateRoute.propTypes = {
  // The element to render (should be a React element).
  element: PropTypes.element.isRequired,
  // Optional resource type for permissions checking.
  resourceType: PropTypes.string,
  // Optional resource key for permissions checking.
  resourceKey: PropTypes.string,
};

export default PrivateRoute;
